import { makeStyles } from '@material-ui/core';
import { DsText } from '@mvp/design-system';
import React, { FC } from 'react';
import { NA } from '../../../store/constants';
import { formatToDollarAmount } from '../../../utils/string';

const useStyles = makeStyles((theme) => ({
  capitalizeText: {
    textTransform: 'capitalize'
  },
}))

const formatDeductibleAndLimitInfo = (info: string) => {
  // if info is N/A return that
  if (info === NA || info.toLowerCase() === 'none') {
    return {
      person: NA,
      family: '',
    }
  }

  // if info does not contain a slash, return the info formatted
  if (!info.includes('/')) {
    return {
      person: `${formatToDollarAmount(info)} / Person`,
      family: '',
    }
  };
  const splitBasedOnSlash = info.split('/');
  const splitBasedOnSpace = splitBasedOnSlash.map((item) => item.trim().split(' '));
  return {
    [`${splitBasedOnSpace[0][1]}`]: `${splitBasedOnSpace[0][0]} / ${splitBasedOnSpace[0][1]}`,
    [`${splitBasedOnSpace[1][1]}`]: `${splitBasedOnSpace[1][0]} / ${splitBasedOnSpace[1][1]}`,
  }
}

interface AnnualDeductibleOrLimitProps {
  title: string;
  annualDeductibleOrLimitValue: string;
}

const AnnualDeductibleOrLimit: FC<AnnualDeductibleOrLimitProps> = ({ title, annualDeductibleOrLimitValue }) => {
  const classes = useStyles();
  const annualDeductibleOrLimitInfo = formatDeductibleAndLimitInfo(annualDeductibleOrLimitValue);

  return (
    <>
      <DsText variant="overline" text={title} />
      {
        annualDeductibleOrLimitValue.toLowerCase() === 'n/a' ? (
          <DsText variant="body2" text={annualDeductibleOrLimitValue.toUpperCase()} />
        ) : (
          <>
            <DsText className={classes.capitalizeText} variant="body2" text={annualDeductibleOrLimitInfo.person} />
            <DsText className={classes.capitalizeText} variant="body2" text={annualDeductibleOrLimitInfo.family} />
          </>
        )
      }
    </>
  )
}

export default AnnualDeductibleOrLimit